<p-dialog [header]="header" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '40vw' }" [modal]="true" [closable]="true" [(visible)]="showDialog" (visibleChange)="showDialogChange.emit($event)" >
    <ng-content></ng-content>
    <ng-template #footer>
        <p-button *ngIf="rejectLabel.length > 0" [label]="rejectLabel" [outlined]="true" severity="secondary" (click)="reject()" />
        <p-button *ngIf="acceptLabel.length > 0" [label]="acceptLabel" class="ms-2" (click)="accept()" />
    </ng-template>
</p-dialog>